import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useXtimeAppointmentState } from "../blocks/Cart/Page/XTimeAppointment/useXtimeAppointmentState";
import { useLanguage } from "../i18n/useLanguage";
import { useCart } from "../stores/hooks/useCart";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";

export const useGetXtimeAppointmentIntegrationUrl = (): ModifiedSWRResponse<
  FetcherResult<Payload>,
  Payload
> => {
  const cart = useCart();
  const dealerInfo = useNullableDealerAccountInfo();
  const shouldRenderAppointmentButton = useXtimeAppointmentState();

  const [language] = useLanguage();

  const shouldFetch = Boolean(
    cart && dealerInfo && shouldRenderAppointmentButton
  );

  const result = useSwrGet<Payload>(
    shouldFetch
      ? "/retailSiteWebService/shopping/thirdParty/getXtimeAppointmentIntegrationUrl.php"
      : null,
    shouldFetch
      ? {
          customerEmail: cart?.customerEmail || "",
          customerLanguage: language,
          customerName: cart?.customerName || "",
          customerPhone: cart?.customerPhone || "",
          dealerId: dealerInfo!.dealerId,
          notes: cart?.customerNotes || "",
          orderNumber: cart!.orderNumber,
          orderType: cart!.orderTypeCode,
        }
      : {}
  );
  return result;
};

type Payload = {
  customerInformationSaved: boolean;
  xtimeAppointmentIntegrationUrl: string;
};
